import React, {useEffect, useRef, useState} from "react"
import {ViewThemeDetails} from "../../selected-theme/view-theme/ViewThemeDetails";
import {NavLink, Switch} from "react-router-dom";
import {ContentRoute} from "../../../../../../_metronic/layout";
import {useGetThemesQuery, useUpdateThemesOrderMutation} from "../../../../../../redux/apiSlice";
import Skeleton from "react-loading-skeleton";
import cogoToast from "cogo-toast";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../../../../_metronic/_helpers";
import {permissionCssClass} from "../../../../../util/Helpers";
import {Permissions, PermissionType} from "../../../../../util/Permissions";
import {shallowEqual, useSelector} from "react-redux";
import {DragIndicator} from '@mui/icons-material';

export const ViewThemes = ({match}) => {
    const adminUser = useSelector(({auth}) => (auth.user), shallowEqual);
    const {isFetching, data: themes } = useGetThemesQuery(match?.params?.userGroup)
    const [canSortThemes, setCanSortThemes] = useState(false)

    const [sortedThemes, setSortedThemes] = useState([])
    const movedThemes = useRef({})

    const [
        updateThemesOrder, // This is the mutation trigger
        {
            isLoading: isUpdating,
            isSuccess: updatedSuccessfully,
        }, // This is the destructured mutation result
    ] = useUpdateThemesOrderMutation()

    useEffect(() => {
        if (themes) {
            const themesCopy = []
            for (const theme of themes) {
                themesCopy.push({...theme, meta: {...theme.meta}})
            }
            setSortedThemes(themesCopy)
        }
    }, [themes]);

    useEffect(() => {
        if (updatedSuccessfully) {
            cogoToast.success("Created 'Themes Rearrangement' Action Successfully")
            movedThemes.current = {}
            setCanSortThemes(false)
        }
    }, [updatedSuccessfully]);

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const onSaveOrder = () => {
        const oldOrder = []
        const newOrder = []

        for (const theme of themes) {
            oldOrder.push(theme.name)
        }

        for (const theme of sortedThemes) {
            newOrder.push(theme.name)
        }

        updateThemesOrder({
            userGroup: match?.params?.userGroup,
            metadata: Object.values(movedThemes.current),
            meta: {oldOrder, newOrder}
        })
    }

    function onDragEnd(result) {
        // dropped outside the list
        if (!result.destination || result.destination.index === result.source.index) {
            return;
        }

        const items = reorder(
            sortedThemes,
            result.source.index,
            result.destination.index
        );

        for (let i = 0; i < items.length; i++) {
            if (items[i].id === result.draggableId) {
                const updatedMeta = {id: items[i].id, ...items[i].meta}
                if (i === 0) {
                    updatedMeta.priority = items[i + 1].meta.priority + 100;
                } else if (i === items.length - 1) {
                    updatedMeta.priority = items[i - 1].meta.priority - 100;
                } else {
                    updatedMeta.priority = (items[i - 1].meta.priority + items[i + 1].meta.priority) / 2;
                }
                movedThemes.current[result.draggableId] = updatedMeta
            }
        }

        setSortedThemes(items)
    }

    return (
        <div className={"col h-100"}>
            <div className="row h-100">
                <div className={`col mr-6 pb-4 card card-custom ${canSortThemes && "border border-primary"}`}>
                    {/* <!--begin::Header--> */}
                    <div className="card-header px-6 border-0">
                        <h3 className="card-title font-weight-bolder text-dark">{canSortThemes ? "Rearrange Themes" : "Themes"}</h3>
                        {
                            themes && <div
                                className={`card-toolbar ${permissionCssClass(adminUser, Permissions.THEMES, PermissionType.UPDATE)}`}
                            >
                                {
                                    (themes && !canSortThemes) && <button
                                        onClick={() => setCanSortThemes(true)}
                                        title="Rearrange Themes"
                                        className="btn btn-icon btn-default border btn-bg-white btn-hover-light-primary btn-sm"
                                    >
                                        <span
                                            className="svg-icon svg-icon-md svg-icon-primary position-relative">
                                            <SVG
                                                title=" "
                                                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                                            />
                                        </span>
                                    </button>
                                }
                            </div>
                        }
                    </div>
                    {
                        themes && canSortThemes && <div className={"d-flex mb-6 mx-4"}>
                            <button
                                disabled={isUpdating}
                                onClick={() => setCanSortThemes(false)}
                                title="Cancel"
                                className="btn btn-default mr-4 col"
                            >
                                Cancel
                            </button>
                            <button
                                disabled={isUpdating}
                                onClick={onSaveOrder}
                                title="Save Order"
                                className="btn btn-primary col"
                            >
                                Save Order
                            </button>
                        </div>
                    }
                    {/* <!--end::Header--> */}
                    <div className="navi navi-bold navi-hover navi-active navi-link-rounded">
                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="droppable">
                                {(provided) => (
                                    <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                    >
                                        {
                                            isFetching
                                                ? <Skeleton height={"1.5rem"} width="100%" count={16}
                                                            style={{margin: "0.75rem 0"}}/>
                                                : sortedThemes && sortedThemes.map((theme, index) => {
                                                return (
                                                    canSortThemes
                                                        ? <Draggable
                                                            key={theme.id}
                                                            draggableId={theme.id}
                                                            index={index}
                                                        >
                                                            {(provided, snapshot) => (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    className={`navi-item ${snapshot.isDragging && "border rounded border-primary bg-white"}`}
                                                                >
                                                                    <div className="navi-link py-4">
                                                                        {
                                                                            movedThemes.current[theme.id] && <span
                                                                                className="rounded-circle bg-primary p-2 mr-2"
                                                                            />
                                                                        }
                                                                        <span
                                                                            className="navi-text font-size-lg">{theme.name}
                                                                        </span>
                                                                        <span
                                                                            className="svg-icon svg-icon-md svg-icon-primary">
                                                                            <DragIndicator/>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                        : <NavLink key={theme.id}
                                                                   to={`/themes/view/${match.params.userGroup}/${theme.id}`}
                                                                   className="navi-item">
                                                            <div className="navi-link py-4">
                                                                <span
                                                                    className="navi-text font-size-lg">{theme.name}
                                                                </span>
                                                            </div>
                                                        </NavLink>
                                                )
                                            })
                                        }
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
                <div className="col-9 border-light">
                    <Switch>
                        <ContentRoute path="/themes/view/:userGroup/:themeId" component={ViewThemeDetails}/>
                    </Switch>
                </div>
            </div>
        </div>
    )
}